/**
 * Daily-scene loader. Resolves today's bundle URL and loads `day_meta.json`.
 *
 * In dev (no API), falls back to a local placeholder bundle under `/public/days/`.
 */

import type { DayMeta, TodayResponse } from './dayMeta';

const TODAY_ENDPOINT = import.meta.env.VITE_TODAY_ENDPOINT ?? '';
const LOCAL_FALLBACK_DAY = 'S1D01';

export async function fetchToday(): Promise<TodayResponse> {
  if (TODAY_ENDPOINT) {
    try {
      const res = await fetch(TODAY_ENDPOINT, { cache: 'no-store' });
      if (res.ok) {
        return (await res.json()) as TodayResponse;
      }
      console.warn('[loader] /today returned', res.status, '— using local fallback');
    } catch (err) {
      console.warn('[loader] /today fetch failed — using local fallback', err);
    }
  }

  // Local dev fallback: serve the placeholder day from /public.
  const today = new Date().toISOString().slice(0, 10);
  return {
    id: LOCAL_FALLBACK_DAY,
    date: today,
    bundleUrl: `/days/${LOCAL_FALLBACK_DAY}/`,
    encore: false,
  };
}

export async function loadDayMeta(bundleUrl: string): Promise<DayMeta> {
  const url = `${bundleUrl}day_meta.json`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to load day_meta.json from ${url}: ${res.status}`);
  }
  return (await res.json()) as DayMeta;
}
